export default "__VITE_ASSET__Cyni8IoW__"